import posted from "../static/posted";
import pagination from "../static/pagination";
import exportData from "../static/exportData";

const moduleName = "mesinEdcModule";

const state = {
    //Api
    isFetching: false,
    isLoadMore: false,
    exportData: exportData(),
    exportProgress: {
        processed: 0,
        total: 0,
    },
    response: {},
    hasChange: false,
    pagination: pagination(),
    paginationSettlement: pagination(),
    paginationRiwayatPembayaran: pagination(),

    //ListOptions
    listProvider: [],
    listOutlet: [],
    listSettlement: [],

    //Data
    listMesinEdc: [],
    listMesinEdcAll: [],
    dataMesinEdc: {
        data: [],
        total: 0,
        saldo: 0,
        tglAwal: "",
        tglAkhir: "",
    },
    detailMesin: {},
    posted: posted(),
    displayCard: [],
    lastItemToView: {},
    endItemOfPage: {},
    lastSettlementToView: {},
    endSettlementOfPage: {},
    endPembayaranOfPage: {},

    //Data Settlement
    listPembayaran: [],
    listSettlementEdc: [],
    totalSettlementEdc: "",
    detailSettlementEdc: {},
    selectedPembayaran: [],

    //Data Riwayat Pembayaran
    listPembayaranEdc: [],
    totalPembayaranEdc: "",
};

export { state as default, moduleName };
